import { createFileRoute } from '@tanstack/react-router';

import { PeoplePage } from '@/features/admin/PeoplePage';
import type { RoleTab } from '@/features/admin/people/types';
import { requireRouteAccess } from '@/lib/routeGuards';

const TABS: RoleTab[] = ['students', 'teachers', 'parents'];

export const Route = createFileRoute('/_authed/admin/people')({
  beforeLoad: () => requireRouteAccess('/admin/people'),
  /** Active people tab lives in the URL (?tab=…) so links can deep-link a tab. */
  validateSearch: (search: Record<string, unknown>): { tab?: RoleTab } =>
    TABS.includes(search.tab as RoleTab) ? { tab: search.tab as RoleTab } : {},
  component: PeoplePage,
});
